var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9 220.7C73.9 220.7 70.6 217.4 70.6 213.4V70.1C70.6 55.7 82.2 44.1 96.6 44.1H205.5C209.5 44.1 212.8 47.4 212.8 51.4V194.8C212.8 198.8 209.5 202.1 205.5 202.1C201.5 202.1 199.2 198.8 199.2 194.8V57.8H96.7C90.4 57.8 84.3 63.9 84.3 70.2V213.6C84.3 217.4 82 220.7 77.9 220.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.6 238.4H96.7C82.3 238.4 70.7 227.8 70.7 213.4C70.7 199 82.3 188.4 96.7 188.4H205.6C209.6 188.4 212.9 190.7 212.9 194.7C212.9 198.7 209.6 202 205.6 202H96.7C90.4 202 85.3 207.1 85.3 213.4C85.3 219.7 90.4 224.8 96.7 224.8H205.6C209.6 224.8 212.9 228.1 212.9 232.1C212.9 236.1 209.6 238.4 205.6 238.4Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.1 238.2C193.1 238.2 190.8 234.9 190.8 230.9V194.7C190.8 190.7 193.1 188.4 197.1 188.4C201.1 188.4 204.4 190.7 204.4 194.7V231C204.4 234.9 201.1 238.2 197.1 238.2Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.3 152.2C154 152.2 152 150.7 151.3 148.5L141.8 115.2L132.3 148.5C131.6 151.3 128.7 152.9 126 152.2C123.2 151.5 121.6 148.6 122.3 145.9C122.3 145.8 122.4 145.8 122.4 145.7L136.8 95.1C137.6 92.3 140.4 90.7 143.2 91.5C144.9 92 146.3 93.3 146.8 95.1L161.2 145.7C162 148.5 160.4 151.3 157.6 152.1C157.3 152.1 156.8 152.2 156.3 152.2Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.6 138.4H131.3C128.5 138.4 127.1 136.1 127.1 133.2C127.1 130.4 128.4 128 131.3 128H152.6C155.4 128 156.8 130.3 156.8 133.2C156.8 136.1 155.5 138.4 152.6 138.4Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/book.b2dc967a.svg";
export { ForwardRef as ReactComponent };